import { createSelector } from 'reselect'

import { initialState } from '../reducers/elasticAggregatesReducer'

// select state from store
export const stateSelector = (state) => state.elasticAggregates || initialState

export const brandSelector = createSelector(stateSelector, (state) => state.brand)
export const contentTypeSelector = createSelector(stateSelector, (state) => state.contentType)
export const intervalSelector = createSelector(stateSelector, (state) => state.interval)
export const fieldSelector = createSelector(stateSelector, (state) => state.field)

export const brandsAggregatesSelector = createSelector(stateSelector, (state) => state.brandsAggregates)
export const brandsAggregatesFetchingSelector = createSelector(stateSelector, (state) => state.brandsAggregatesFetching)
export const brandsAggregatesFetchedSelector = createSelector(stateSelector, (state) => state.brandsAggregatesFetched)
export const brandsAggregatesErrorSelector = createSelector(stateSelector, (state) => state.brandsAggregatesError)

export const contentTypesAggregatesSelector = createSelector(stateSelector, (state) => state.contentTypesAggregates)
export const contentTypesAggregatesFetchingSelector = createSelector(stateSelector, (state) => state.contentTypesAggregatesFetching)
export const contentTypesAggregatesFetchedSelector = createSelector(stateSelector, (state) => state.contentTypesAggregatesFetched)
export const contentTypesAggregatesErrorSelector = createSelector(stateSelector, (state) => state.contentTypesAggregatesError)

export const documentsAggregatesSelector = createSelector(stateSelector, (state) => state.documentsAggregates)
export const documentsAggregatesFetchingSelector = createSelector(stateSelector, (state) => state.documentsAggregatesFetching)
export const documentsAggregatesFetchedSelector = createSelector(stateSelector, (state) => state.documentsAggregatesFetched)
export const documentsAggregatesErrorSelector = createSelector(stateSelector, (state) => state.documentsAggregatesError)
